import * as React from 'react';
import { SVGProps } from 'react';

const IconDragSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 3 8 0l3.5 3H9v4h4V4.5L16 8l-3 3.5V9H9v4h2.5L8 16l-3.5-3H7V9H3v2.5L0 8l3-3.5V7h4V3H4.5z" />
  </svg>
);
export default IconDragSizeS;
